import { useAppSelector, useTranslate } from '@common/hooks'
import ModalWrapper from '@common/modals/ModalWrapper'
import Button from '@common/widgets/Button'
import cx from 'classnames'
import { useRef, useState } from 'react'

import classNames from './styles.module.scss'
import ModalInstruction from './widgets/ModalInstruction'


export default function BroadcastOverlays(): JSX.Element | null {
  const [statusSuccessAction, setStatusSuccessAction] = useState<null | string>(null)
  const application = useAppSelector(store => store.application?.data) as IApplication
  const successTimeoutRef = useRef<NodeJS.Timeout | null>(null)
  const { translate } = useTranslate()
  const [formIsOpen, setFormIsOpen] = useState(false)
  const isDisalbed = !application.isInstalled

  const handleCopy = async (link: string, name: string) => {
    if(isDisalbed) {
      return
    }
    try {
      await navigator.clipboard.writeText(link)
      if(successTimeoutRef.current) {
        clearTimeout(successTimeoutRef.current)
      }
      setStatusSuccessAction(name)
      successTimeoutRef.current = setTimeout(() => {
        setStatusSuccessAction(null)
        successTimeoutRef.current = null
      }, 2000)
    } catch (err: unknown) {
      console.error(err)
      if(window.newrelic) {
        window.newrelic.noticeError(err, {
          errorType: 'client',
          errorName: 'Broadcast Overlays Copy Error',
        })
      }
    }
  }

  if(!application?.latest?.broadcastOverlays) {
    return null
  }
  const LinkComponent = isDisalbed ? 'span' : 'a'

  return <div className={classNames.wrapper}>
    <div className={classNames.overlayList}>
      {Object.entries(application.latest.broadcastOverlays).map(([name, overlay], ind) => (
        <div key={name} className={classNames.overlayRow} data-test="overlay-row">
          <div className={classNames.overlayName}>
            <LinkComponent
              className={cx(classNames.layerTitle, {
                [classNames.disabled]: isDisalbed,
              })}
              href={overlay.link}
              target="_blank"
              rel="noreferrer"
              data-test={`overlay-link-${ind}`}
              onClick={(ev) => {
                if(isDisalbed) {
                  ev.preventDefault()
                }
              }}
            >
              <span className={classNames.linkTitle} data-test={`overlay-title-${ind}`}>{overlay.title}</span>
              <span className={classNames.size} data-test={`overlay-size-${ind}`}>{`${overlay.width}x${overlay.height}`}</span>
            </LinkComponent>
            <div
              key={name}
              className={cx(classNames.actionBar, {
                [classNames.disabled]: isDisalbed,
              })}
              data-test="overlay-action-bar"
            >
              <i
                className={cx(classNames.iconCopy, {
                  [classNames.disabled]: isDisalbed,
                })}
                data-test="icon-copy"
                onClick={handleCopy.bind(null, overlay.link, name)}
              />
              <div
                className={cx(classNames.response, {
                  [classNames.active]: statusSuccessAction === name,
                })}
                data-test="overlay-response"
              >
                {translate('Copied')}
                <i className={classNames.success} data-test="icon-success"/>
              </div>
            </div>
          </div>
          <div className={classNames.description} data-test="overlay-description">
            {overlay.description}
          </div>
        </div>
      ))}
    </div>
    <div className={classNames.overlayInstruction} data-test="overlay-instruction">
      {!isDisalbed && (
        <>
          <h3
            className={classNames.title}
            data-test="overlay-instruction-title"
          >
            {translate('How to use Broadcast Overlays')}
          </h3>
          <Button
            width="lg"
            variant="light"
            onClick={() => setFormIsOpen(true)}
            data-test="overlay-instruction-btn"
          >
            {translate('Launch Tutorial')}
          </Button>
        </>)}
    </div>
    <ModalWrapper
      component={ModalInstruction}
      show={formIsOpen}
      onHide={() => {
        setFormIsOpen(false)
      }}
      size="lg"
      modalClassName={classNames.modal}
    />
  </div>
}
